/**
 * Common routes of the application
 */

import React from "react";
import { Route } from "react-router-dom";
import { Unauthorized } from "us.common/components";
import { AuthCallback } from "us.common/containers";


export default [
  <Route
    
    key="/unauthorized"
    path={"/unauthorized"}
    element={<Unauthorized />}
  />,
  <Route
    
    key="/authcallback"
    path={"/authcallback"}
    element={<AuthCallback />}
  />
];
